import ThreePage from "./pages/ThreePage";
import './Twocss.css';

function App() {
    return (
        <div>
            <ThreePage/>
        </div>
    );
}

export default App;
